import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function TestimonialSection() {
  const testimonials = [{
    name: 'Laura Martínez',
    role: 'Prof. Secundaria, Madrid, España',
    text: 'Antes me quedaba hasta las 2 de la mañana buscando actividades. Con este pack, en 10 minutos tengo la semana resuelta. Es literal un salvavidas.',
    initial: 'L',
    color: 'bg-pink-500'
  }, {
    name: 'Carolina Vega',
    role: 'Instituto Privado, Ciudad de México',
    text: 'Lo que más me gusta es el orden. No son actividades sueltas, es un sistema. Mis alumnos notaron la diferencia y yo estoy mucho más tranquila.',
    initial: 'C',
    color: 'bg-purple-500'
  }, {
    name: 'Mariana Silva',
    role: 'Clases Particulares, São Paulo, Brasil',
    text: 'La inversión se paga sola con el tiempo que ahorrás. Dejé de improvisar y ahora entro a mis clases segura. El material es excelente.',
    initial: 'M',
    color: 'bg-blue-500'
  }, {
    name: 'Andrea Fernández',
    role: 'Primaria y Secundaria, Lima, Perú',
    text: 'Estaba a punto de dejar horas porque no daba abasto. Este pack me devolvió las ganas de enseñar. Simplemente gracias.',
    initial: 'A',
    color: 'bg-indigo-500'
  }, {
    name: 'Sofía Ramírez',
    role: 'Prof. Inglés, Bogotá, Colombia',
    text: 'Increíble la cantidad de material. Los bonos son un plus gigante. Si sos profe y estás cansada, necesitás esto sí o sí.',
    initial: 'S',
    color: 'bg-teal-500'
  }];
  return <section className="py-20 bg-gray-50" data-id="element-221">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-222">
        <div className="text-center mb-16" data-id="element-223">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-224">
            Docentes reales que recuperaron su vida
          </h2>
          <p className="text-gray-600 text-lg" data-id="element-225">
            Ellas también estaban sobrecargadas. Hoy enseñan diferente.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-226">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 relative hover:shadow-md transition-shadow" data-id="element-227">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-blue-100" data-id="element-228" />

              <div className="flex items-center gap-1 mb-5" data-id="element-229">
                {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-4 h-4 text-yellow-400 fill-current" data-id="element-230" />)}
              </div>

              <p className="text-gray-700 mb-6 italic leading-relaxed text-lg" data-id="element-231">
                "{t.text}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-232">
                <div className={`w-12 h-12 ${t.color} rounded-full flex items-center justify-center text-white font-bold text-lg shadow-sm`} data-id="element-233">
                  {t.initial}
                </div>
                <div data-id="element-234">
                  <p className="font-bold text-gray-900" data-id="element-235">{t.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-236">{t.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-237">
          <CTAButton text="QUIERO MI PACK AHORA" data-id="element-238" />
        </div>
      </div>
    </section>;
}